import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {OrderType} from '../types'

const QueryKey = 'order-types'

export const useOrderTypes = (
  options?: Omit<UseQueryOptions<OrderType[], AxiosError>, 'queryKey'>
) => {
  const path = '/work-orders/order-types'

  return useQuery<OrderType[], AxiosError>({
    queryKey: [QueryKey],
    queryFn: async () => {
      const {data} = await ApiClient.axiosInstance.get<OrderType[]>(path)
      return data
    },
    ...options
  })
}
